import { Popover } from '@material-ui/core';
import { IconButton } from 'copilot-design-system';
import { ReactNode, useState } from 'react';

export const MobileInfoPopover = ({ children }: { children: ReactNode }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        icon="Info"
        label="Info"
        variant="minimal"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className="hover:cursor-pointer hover:bg-gray-100 text-gray-small w-7 h-7 p-0 inline-flex items-center justify-center [&>*]:w-4 [&>*]:h-4"
      />
      <Popover
        open={anchorEl !== null}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 6,
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        onClose={() => setAnchorEl(null)}
        classes={{
          paper:
            'border border-solid border-secondary-hover shadow-dropdown-menu p-3 max-w-[80%]',
        }}
      >
        {children}
      </Popover>
    </>
  );
};
